import { showLengthWithUnits } from 'ws-units'

class SpanDialogComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('project-loaded', (event) => this.configure(event.detail))
    document.addEventListener('spans-did-change', (event) => this.configure(event.detail)) 
  }

  configure(project) {
    let str = "<table class='table table-borderless'>";
    for(let i = 0; i < project.beam.spans.length; i++ ) {
        str += `<tr><td style='width:100px;'>Span ${i + 1}</td>`
        str += `<td><input style='width:100px;' id='span-input-${i}' type='text'`
        str += `value='${showLengthWithUnits(project.beam.spans[i].length(), true)}'/></td>`
        if(project.beam.spans.length > 1) {
            str += `<td><button type='button' class='btn btn-sm btn-danger' id='remove-span-${i}'>Remove</button></td>`
        }
        str += "</tr>"
    }
    str += "</table>";

    document.getElementById('span-table').innerHTML = str

    for(let i = 0; i < project.beam.spans.length; i++ ) {
      if(project.beam.spans.length > 1) {
        document.getElementById(`remove-span-${i}`).onclick = () => { 
          document.dispatchEvent(new CustomEvent('remove-span', { detail: i }))
        }
      }
      
      document.getElementById(`span-input-${i}`).onchange = () => { 
        document.dispatchEvent(new CustomEvent('span-length-changed', { detail: i }))
      }
    }
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="modal-span-dialog" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <h1 class="modal-title fs-5">Edit Spans</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body modal-body-shadow">
            <div class="panel panel-warning d-none" id="design-available-warning">
              <div class="panel-heading" id="span-dialog-warning-text"></div>
            </div>
            <div class="text-center">  
              <button id="add-left-span-button" type="button" class="btn btn-primary button-shadow btn-md">
                Add Left Span
              </button>
              <button id="add-right-span-button" type="button" class="btn btn-primary button-shadow btn-md">
                Add Right Span
              </button>
            </div>
          </div>

          <div class="modal-body">
            <div id="span-table"></div>
            <div class="alert alert-info" role="alert">
              <strong>Pro tip!</strong> Support Conditions can be changed by clicking on them in the drawing.
            </div>
          </div>  
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    `
  }

}

customElements.define('span-dialog-component', SpanDialogComponent)
